import type { SheetHeaderProps } from './Sheet.types'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Button } from '../button'
import * as React from 'react'
import { TopTitleBar } from '../top-title-bar'
import styles from './Sheet.module.css'

export function Header({ titleLabel, closeLabel, children, className }: SheetHeaderProps) {
  return (
    <>
      <DialogPrimitive.Title className={styles.dialogTitle}>
        {titleLabel}
      </DialogPrimitive.Title>
      <TopTitleBar.Root className={className}>
        <TopTitleBar.LeftArea>{children}</TopTitleBar.LeftArea>
        <TopTitleBar.CenterArea title={titleLabel} />
        <TopTitleBar.RightArea>
          <Close>
            <Button variant="transparentPrimary">{closeLabel}</Button>
          </Close>
        </TopTitleBar.RightArea>
      </TopTitleBar.Root>
    </>
  )
}

export function Close({ children }: React.PropsWithChildren) {
  return <DialogPrimitive.Close asChild>{children}</DialogPrimitive.Close>
}
